export const FETCH_THING_REQUEST = "FETCH_THING_REQUEST";
export const FETCH_THING_SUCCESS = "FETCH_THING_SUCCESS";
export const FETCH_THING_FAILURE = "FETCH_THING_FAILURE";
export const RESET_THING_STATE = "RESET_THING_STATE";

export const fetchThingRequest = (body) => {
  return {
    type: FETCH_THING_REQUEST,
    payload: body,
  };
};

export const fetchThingSuccess = (data) => {
  return {
    type: FETCH_THING_SUCCESS,
    payload: data,
  };
};

export const fetchThingFailure = (error) => {
  return {
    type: FETCH_THING_FAILURE,
    payload: error,
  };
};

export const resetThingState = () => {
  return {
    type: RESET_THING_STATE,
  };
};
